import { useEffect } from "react";
import { trackSectionView } from "@/lib/analytics";

// Watches every landing-page `*-section` block and fires one "section_view"
// event the first time each becomes 50%+ visible — powers the Top Sections
// chart on the /insights dashboard.
export const useAnalyticsSectionTracking = () => {
  useEffect(() => {
    const sections = document.querySelectorAll('[data-testid$="-section"]');
    const seen = new Set();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute("data-testid");
          if (entry.isIntersecting && !seen.has(id)) {
            seen.add(id);
            trackSectionView(id.replace(/-section$/, ""));
          }
        });
      },
      { threshold: 0.5 }
    );

    sections.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
};
